export const SentimentTypeMapTab ={
  positive: "positive",
  negative: "monitor",
};

export const SentimentTypeFilterMap: Record<string, number> = {
  positive: 5,
  negative: 1,
};
